/**
 * Fiskal Cloud Selfcare API
 * # Overview  ## TSS pre-initialization Pre-initializes TSS with following options: * creating cloud TSS (with CSP account) for ERS that are not assigned to any TSS * creating cloud TSS (with CSP account) for BP that doesn\'t have any TSS * activation of inactive TSS and creation of CSP account 
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TssPreInitializationModeDTO } from './tss-pre-initialization-mode-dto';


/**
 * Request with data for TSS pre-initialization
 */
export interface TssPreInitializationRequestDTO { 
    mode: TssPreInitializationModeDTO;
    /**
     * Optional ERS secret to be set. Alphanumeric characters, 4 or longer
     */
    ersSecret?: string;
}

export class ClsTssPreInitializationRequestDTO { 
    mode: TssPreInitializationModeDTO = undefined;
    /**
     * Optional ERS secret to be set. Alphanumeric characters, 4 or longer
     */
    ersSecret?: string = undefined;
}



